import mixpanel from 'mixpanel-browser';
import { logger } from '@orionprotocol/common';

import { Analytics } from '../Analytics';

type MixpanelFactoryConfig = {
  app_key: string | undefined;
  url: string;
  onInitError?(error: unknown): void;
};

export const createMixpanelAnalytics = ({
  app_key,
  url,
  onInitError,
}: MixpanelFactoryConfig): Analytics => {
  if (app_key === undefined) {
    logger.error('Mixpanel app_key is not defined');
    return {
      sendEvent: (): void => {
        // empty func
      },
    };
  }

  try {
    mixpanel.init(app_key, { track_pageview: true, api_host: url });

    return {
      sendEvent: (
        eventName: string,
        eventData: Record<string, unknown>,
      ): void => {
        mixpanel.track(eventName, eventData);
      },
    };
  } catch (e) {
    onInitError?.(e);
    logger.error(e);
    logger.error('Mixpanel was not initialized. Can not send events');

    return {
      sendEvent: (): void => {
        // empty func
      },
    };
  }
};
